import { nullable } from '@ipfabric/utils/fp/nullable';
import { prop } from '@ipfabric/utils/fp/prop';
import type { GraphState } from 'components/Graph/GraphState';
import {
  type SeverityWithCount,
  getPathLookupEventsSeverity,
} from 'components/Graph/helpers/getPathLookupEventsSeverity';
import { selectPathLookupMetadata } from 'components/Graph/model/selectors/graphMetadata/selectPathLookupMetadata';
import { flow } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectPathLookupResultSeverity: (
  s: GraphState,
) => SeverityWithCount | null = createScopedSelector(() =>
  createSelector(
    flow(selectPathLookupMetadata, nullable.chain(prop('eventsSummary'))),
    nullable.chain(getPathLookupEventsSeverity),
  ),
);
